import { useQuery } from '@tanstack/react-query';

import { getFileType } from '@/shared/lib/utils/fileType';

import { downloadArtifact, fetchArtifactsList } from '@/entities/artifact/api';

const ARTIFACT_KEYS = {
  all: ['artifacts'] as const,
  list: (runId: string, path?: string) => [...ARTIFACT_KEYS.all, 'list', runId, { path }] as const,
  content: (runId: string, path: string) => [...ARTIFACT_KEYS.all, 'content', runId, { path }] as const,
};

export const useArtifacts = (runId: string, path?: string) => {
  return useQuery({
    queryKey: ARTIFACT_KEYS.list(runId, path),
    queryFn: () => fetchArtifactsList(runId, path),
    enabled: !!runId,
  });
};

export const useArtifactContent = (runId: string, path: string, enabled: boolean) => {
  const fileType = getFileType(path);

  return useQuery({
    queryKey: ARTIFACT_KEYS.content(runId, path),
    queryFn: async () => {
      const blob = await downloadArtifact(runId, path);

      if (fileType === 'json') {
        const text = await blob.text();
        return JSON.parse(text);
      }

      if (fileType === 'text') {
        return await blob.text();
      }

      return blob;
    },
    enabled: !!runId && !!path && enabled,
    staleTime: Infinity,
  });
};
